import React from 'react';
import { assest } from '../../Assest/Assest';

function TeethWhitening() {
  return (
    <div style={styles.container}>
      <img 
        src={assest.TeethWhitening}
        alt="Teeth Whitening" 
        style={styles.image} 
      />
      <div style={styles.content}>
        <h2 style={styles.title}>Professional Teeth Whitening</h2>
        <p style={styles.text}>
          Brighten your smile with our advanced teeth whitening services. At our clinic, we use state-of-the-art 
          technology to provide safe, effective, and long-lasting results. Whether you're looking to remove stubborn 
          stains from coffee, tea, or other factors, or you're preparing for a special event, our whitening solutions 
          are designed to give you the confidence to show off your smile.
        </p>
        <p style={styles.text}>
          Our expert team will assess your teeth and recommend the best treatment for your needs. The process is quick, 
          painless, and designed to provide results you can see immediately. With our professional care, you'll leave 
          feeling refreshed and looking your best.
        </p>
        <p style={styles.text}>Book an appointment today and start your journey to a brighter smile!</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#f9f9f9',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
  },
  containerHover: {
    transform: 'translateY(-10px)',
  },
  image: {
    width: '100%',
    maxWidth: '800px',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
  },
  imageHover: {
    transform: 'scale(1.05)',
  },
  content: {
    marginTop: '30px',
  },
  title: {
    fontSize: '2.5rem',
    color: '#2e2e2e',
    fontWeight: '700',
    marginBottom: '20px',
  },
  text: {
    fontSize: '1.1rem',
    color: '#555',
    lineHeight: '1.7',
    maxWidth: '800px',
    margin: '0 auto',
    paddingBottom: '10px',
    transition: 'color 0.3s ease-in-out',
  },
  textHover: {
    color: '#4caf50',
  },
};

export default TeethWhitening;
